module.exports = __webpack_public_path__ + "media/加油.e84ea52c.mp3";